export default {
  completeProfile: {
    intro: {
      title: "Vamos a dejar todo listo",
      subtitle: "Unos permisos rápidos nos ayudan a mostrar cuotas más relevantes, enviarte actualizaciones oportunas y mejorar tu experiencia general.",
    },
    tracking: {
      title: "Ayuda a mantener Linemate gratis",
      subtitle: "Te pedimos permiso para rastrear parte de la actividad en este dispositivo. Al seleccionar “Permitir rastreo” en la siguiente pantalla, nos ayudarás a:",
      buttonSubtext: "Puedes cambiar esta opción más tarde en la app de Configuración",
      cards: {
        support: {
          title: "Apoya a Linemate",
          body: "Esto nos ayuda a seguir mejorando la app y las funciones que más usas.",
        },
        relevantContent: {
          title: "Ver contenido más relevante",
          body: "Usamos estos datos para mostrarte ofertas, tendencias y anuncios más relevantes para ti.",
        },
      },
    },
  },
};